import React from 'react';
import DataModel from '../../../models/DataModel';

import microphoneAnimation from '../../../assets/images/microphone-animation.gif';
import badToneFile from '../../../assets/audio/badbeep.wav';
import handsFreeErrorMsg from '../../../assets/audio/handsFreeErrorMsg.m4a';

import './HandsFreeErrorModal.scss';

class HandsFreeErrorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      playErrorMsg: false,
    };
  
    this.playMessage = this.playMessage.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.closePopup);
  }

  closePopup() {
    document.removeEventListener('click', this.closePopup);
    DataModel.hideGlobalModal();
  }

  playMessage() {
    this.setState({ playErrorMsg: true });
  }

  render() {
    const { playErrorMsg } = this.state;
    
    const audio = !playErrorMsg
      ? <audio src={badToneFile} autoPlay onEnded={this.playMessage} />
      : <audio src={handsFreeErrorMsg} autoPlay onEnded={this.closePopup} />;

    return (
      <div className='HandsFreeErrorModal'>
        { audio }
        <article className='handsfree-error-container' ref={el => this.componentRef = el}>
          <img src={microphoneAnimation} alt='mic'/>
          <h1>I didn't quite catch that</h1>
          <p>{this.props.message}</p>
        </article>
      </div>
    );
  }
}
export default HandsFreeErrorModal;



// WEBPACK FOOTER //
// ./src/components/modals/HandsFreeErrorModal/index.js